import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import Login, { VerifyMagicLink } from "@/pages/Login";
import PublicLeaderboard from "@/pages/PublicLeaderboard";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import ContentManager from "@/pages/ContentManager";
import { Privacy, Terms, Guidelines } from "@/pages/legal";
import MaintenanceGate from "@/components/MaintenanceGate";

// Capture ?ref=NSA-XXXX from ANY entry URL (landing page, product links, etc.) and persist it,
// so a referral is attributed even when the recruit lands somewhere other than /apply first.
function RefCapture() {
  const location = useLocation();
  useEffect(() => {
    try {
      const ref = new URLSearchParams(location.search).get("ref");
      if (ref && /^NSA-/i.test(ref)) localStorage.setItem("ns_ref", ref.toUpperCase());
    } catch (err) {
      console.warn("ref capture failed", err);
    }
  }, [location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RefCapture />
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <MaintenanceGate>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/verify" element={<VerifyMagicLink />} />
            <Route path="/leaderboard" element={<PublicLeaderboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/content-manager" element={<ContentManager />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/guidelines" element={<Guidelines />} />
          </Routes>
        </MaintenanceGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
